<template>
  <div class="import-select-method-page">
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Import </span> /
      <span> Select Method </span>
    </nav>
    <import-steps></import-steps>

    <h2 class="flow-heading pt-5 mt-5">How would you like to import your contacts?</h2>
    <flow-card-group :cards="cards" @selected="onSelected" :selected="selectedCard"></flow-card-group>
    <span class="import-select-method-page__fileimport">
      <add-many-contacts
        ref="importFromFile"
        :vesselId="+vesselId"
        redirectUrl="/inventory/contacts/"
        :platform-title="platformTitle"
        :group-id="queryData.groupId"
      >
      </add-many-contacts>

      <add-many-contacts
        ref="importFromFileToCampaign"
        :vessel-id="+vesselId"
        :campaign-id="+queryData.campaignId"
        :platform-title="platformTitle"
        :redirect-url="'/inventory/campaigns/subscribers/?sk_token=' + queryData.sk_token"
        :select-import-method="false"
        :show-agreement="true"
      >
      </add-many-contacts>
    </span>
    <div>
      <a href="/inventory/contacts/groups/" class="btn btn-lg btn-outline-primary mr-2">Back</a>
      <button @click="onContinue" class="btn btn-lg btn-primary" :class="{disabled: !selectedCard}">Continue</button>
    </div>
  </div>
</template>

<script>
import ImportSteps from '../components/import/ImportSteps';
import FlowCardGroup from '../components/shared/FlowCardGroup';
import AddManyContacts from '../components/AddManyContacts.vue';
export default {
  name: 'import-select-method-page',
  components: {
    ImportSteps,
    FlowCardGroup,
    AddManyContacts,
  },
  props: {
    activeCrm: {
      type: String,
      required: true,
    },
    vesselId: {
      type: String,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedCard: null,
    };
  },
  methods: {
    onSelected(id) {
      this.selectedCard = id;
    },
    onContinue() {
      if (this.selectedCard === 'crm') {
        window.location.href = `/import/select-groups/${window.location.search}`;
      }
      if (this.selectedCard === 'file') {
        if (!this.queryData.campaignId) {
          this.$refs.importFromFile.$refs.trigger.click();
        } else {
          this.$refs.importFromFileToCampaign.$refs.trigger.click();
        }
      }
    },
  },
  computed: {
    cards() {
      return [
        {
          id: 'file',
          name: 'Import from file',
          description: 'Upload your contacts via CSV or tab-delimited TXT file.',
          iconClass: 'fas fa-file-alt',
          itemClass: 'importFromFile',
        },
        {
          id: 'crm',
          name: 'Import from CRM',
          description: 'Import groups and contacts from your connected CRM.',
          iconClass: 'fa fa-th',
          disabled: !this.activeCrm,
        },
      ];
    },
    urlSearchParams() {
      return new URLSearchParams(window.location.search);
    },
    queryData() {
      const {groupId, campaignId, sk_token} = Object.fromEntries(this.urlSearchParams.entries());
      return {groupId, campaignId, sk_token};
    },
  },
};
</script>

<style lang="scss" scoped>
.import-select-method-page {
  &__fileimport {
    position: relative;
    left: 9999px;
  }
}
</style>
